export const toInpMetric = (metric, getHtmlElementMetadata) => {
    const { value, attribution } = metric;
    let htmlElementMetadata = {};
    if (getHtmlElementMetadata && attribution.eventEntry?.target) {
        try {
            htmlElementMetadata = getHtmlElementMetadata(attribution.eventEntry?.target);
        }
        catch (e) {
            // Ignore
        }
    }
    else {
        htmlElementMetadata = {
            compType: 'no-target-element',
        };
    }
    // Retrieve loAF related to this INP only
    const inpStartTime = attribution.eventEntry?.startTime || 0;
    const inpEndTime = (attribution.eventEntry?.startTime || 0) +
        (attribution.eventEntry?.duration || 0);
    const loafs = performance
        .getEntriesByType('long-animation-frame')
        .filter((loaf) => {
        return ((loaf.startTime >= inpStartTime && loaf.startTime <= inpEndTime) ||
            (loaf.startTime + loaf.duration >= inpStartTime &&
                loaf.startTime + loaf.duration <= inpEndTime));
    });
    return {
        inpValue: Math.trunc(value),
        inpRating: metric.rating,
        inpEventType: attribution.eventType,
        inpTargetSelector: attribution.eventTarget,
        inpStartTime: attribution.eventTime
            ? Math.trunc(attribution.eventTime)
            : undefined,
        inpProcessingStart: attribution.eventEntry?.processingStart
            ? Math.trunc(attribution.eventEntry.processingStart)
            : undefined,
        inpProcessingEnd: attribution.eventEntry?.processingEnd
            ? Math.trunc(attribution.eventEntry.processingEnd)
            : undefined,
        inpInteractionId: attribution.eventEntry?.interactionId,
        inpLoadState: attribution.loadState,
        ...(htmlElementMetadata.compType && {
            inpComponentType: htmlElementMetadata.compType,
        }),
        ...(htmlElementMetadata.widgetId && {
            inpWidgetId: htmlElementMetadata.widgetId,
        }),
        ...(htmlElementMetadata.applicationId && {
            inpApplicationId: htmlElementMetadata.applicationId,
        }),
        metadata: { loafs: JSON.stringify(loafs) },
    };
};
//# sourceMappingURL=inp.js.map